module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box purple"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Observações")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body clearfix"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "eventual-medication-notes",
      "name": "eventual-medication-notes",
      "rows": "6",
      "maxlength": "1000"
    },
    domProps: {
      "value": _vm.observation
    },
    on: {
      "change": _vm.putAgendaObservation
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7278d30f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/activities/observation/observation.vue
// module id = 1086
// module chunks = 1